export default "__VITE_ASSET__d2fc99dd__"